import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5003/api';

class ReferenceService {
  constructor() {
    // Check if API_URL already includes /api
    const baseURL = API_URL.includes('/api') 
      ? `${API_URL}/reference`
      : `${API_URL}/api/reference`;
    
    this.api = axios.create({
      baseURL: baseURL,
      timeout: 10000
    });
  }

  // Get all nationalities
  async getNationalities() {
    try {
      const response = await this.api.get('/nationalities');
      return response.data.data || [];
    } catch (error) {
      console.error('Error fetching nationalities:', error);
      return [];
    }
  }

  // Get all blood types
  async getBloodTypes() {
    try {
      const response = await this.api.get('/blood-types');
      return response.data.data || [];
    } catch (error) {
      console.error('Error fetching blood types:', error);
      return [];
    }
  }

  // Get all governorates
  async getGovernorates() {
    try {
      const response = await this.api.get('/governorates');
      return response.data.data || [];
    } catch (error) {
      console.error('Error fetching governorates:', error);
      return [];
    }
  }

  // Get cities by governorate
  async getCitiesByGovernorate(governorateId) {
    try {
      const response = await this.api.get(`/governorates/${governorateId}/cities`);
      return response.data.data || [];
    } catch (error) {
      console.error('Error fetching cities:', error);
      return [];
    }
  }

  // Get all form data at once (more efficient for form initialization)
  async getFormData() {
    try {
      const response = await this.api.get('/form-data');
      return response.data.data || {
        nationalities: [],
        bloodTypes: [],
        governorates: []
      };
    } catch (error) {
      console.error('Error fetching form data:', error);
      return {
        nationalities: [],
        bloodTypes: [],
        governorates: []
      };
    }
  }

  // Find nationality by ID
  async getNationality(id) {
    try {
      const response = await this.api.get(`/nationalities/${id}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching nationality:', error);
      return null;
    }
  }

  // Find blood type by ID
  async getBloodType(id) {
    try {
      const response = await this.api.get(`/blood-types/${id}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching blood type:', error);
      return null;
    }
  }
}

export default new ReferenceService();